import React from 'react'
import { Icon } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Card } from './Card'
import { CardProps } from './types'

export const InitialCard = ({ onButtonPress }: CardProps) => {
  const styles = useStyleSheet(themedStyles)

  return (
    <Card
      icon={<Icon name="shield-star" size={48} weight="fill" style={styles.icon} />}
      title="1-on-1 Coaching Call"
      description="$0 out of pocket with most insurance. You won't be charged."
      buttonTitle="Book your first call"
      onCardPress={onButtonPress}
      onButtonPress={onButtonPress}
    />
  )
}

const themedStyles = StyleService.create({
  icon: {
    color: 'theme.info.base',
  },
})
